<template>
  <div>
    <div class="my-2 d-flex justify-space-between">
      <span>{{ isAdding ? 'Resultados' : 'Selecionados' }} ({{ products.length }})</span>
      <span v-if="!viewOnly" class="link" @click="modifyAllProducts()">{{ isAdding ? 'Selecionar' : 'Remover' }} todos</span>
    </div>
    <div class="products-container my-2">
      <mf-loading loader-type="spinner" :boolean-loader="loading && isAdding">
        <DynamicScroller
          v-if="products.length"
          v-slot="{ item, index, active }"
          class="vue-recycle-scroller scroller ready direction-vertical"
          :items="products"
          :min-item-size="20"
          key-field="_id"
        >
          <DynamicScrollerItem class="cinza-l70-border" :item="item" :active="active" :data-index="index">
            <v-list-item @click="modifyProduct(item)">
              <v-list-item-action v-if="!isAdding && !viewOnly">
                <mf-icon>chevron_left</mf-icon>
              </v-list-item-action>
              <v-list-item-content>
                <span class="body-2">{{ item.sku }} - {{ item.name }}</span>
              </v-list-item-content>
              <v-list-item-action v-if="isAdding">
                <mf-icon>chevron_right</mf-icon>
              </v-list-item-action>
            </v-list-item>
          </DynamicScrollerItem>
        </DynamicScroller>
      </mf-loading>
    </div>
  </div>
</template>

<script>
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  name: 'ProductList',
  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    isAdding: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    modifyProduct(product) {
      if (this.isAdding) {
        this.$emit('addProduct', product)
      } else {
        this.$emit('removeProduct', product)
      }
    },
    modifyAllProducts() {
      if (this.isAdding) {
        this.$emit('addAllProducts')
      } else {
        this.$emit('removeAllProducts')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.products-container {
  background-color: $cinza-l90;
  height: 43vh;
}

.scroller {
  height: 43vh;
  overflow-y: auto;
}

.cinza-l70-border {
  border-bottom: 1px solid $cinza-l70;
}

@media screen and (max-width: 933px) {
  .products-container {
    height: unset;
    min-height: 43vh;
  }

  .scroller {
    height: unset;
    min-height: 43vh;
  }
}
</style>
